export default __webpack_public_path__ + "static/design-40220f8b7d88df7f1c8d34b50725f143.png";